import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HoleCardsContainer } from '../cards/holeCardsContainer';
import { HoleCardsWrapperContainer } from '../cards/holeCardsWrapperContainer';
export const HoleCardsControls = ({ tableAreaDimensions, holeCardsAreaDimensions, gameControlsDimensions }) => {
    const pokerBetControlsX = Math.round(holeCardsAreaDimensions.w);
    const pokerBetControlsY = tableAreaDimensions.h;
    const pokerBetControlsH = gameControlsDimensions.h;
    const x = Math.round(pokerBetControlsX / 2);
    const y = Math.round(pokerBetControlsY + pokerBetControlsH / 2);
    const w = pokerBetControlsX;
    const h = pokerBetControlsH;
    return (_jsx(HoleCardsWrapperContainer, { x: x, y: y, groupContainerW: w, groupContainerH: h, children: _jsx(HoleCardsContainer, { groupContainerW: w, groupContainerH: h }) }));
};
